"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("src/misc/cn");
const JupButton_1 = __importDefault(require("./JupButton"));
const react_1 = require("react");
const SwapContext_1 = require("src/contexts/SwapContext");
const SubmitButton = ({ onSubmit }) => {
    const { quoteResponseMeta, loading, errors, swapping: { txStatus }, form } = (0, SwapContext_1.useSwapContext)();
    const shouldButtonDisabled = (0, react_1.useMemo)(() => {
        if (!quoteResponseMeta ||
            loading ||
            !!errors.fromValue ||
            (txStatus === null || txStatus === void 0 ? void 0 : txStatus.status) === 'loading' ||
            (txStatus === null || txStatus === void 0 ? void 0 : txStatus.status) === 'sending' ||
            (txStatus === null || txStatus === void 0 ? void 0 : txStatus.status) === 'pending-approval') {
            return true;
        }
        return false;
    }, [quoteResponseMeta, loading, errors.fromValue, txStatus]);
    const buttonText = (0, react_1.useMemo)(() => {
        var _a;
        if (errors.fromValue)
            return errors.fromValue.title;
        if ((_a = quoteResponseMeta === null || quoteResponseMeta === void 0 ? void 0 : quoteResponseMeta.quoteResponse) === null || _a === void 0 ? void 0 : _a.errorMessage)
            return quoteResponseMeta.quoteResponse.errorMessage;
        if (loading)
            return 'Loading';
        if ((txStatus === null || txStatus === void 0 ? void 0 : txStatus.status) === 'sending')
            return 'Sending';
        if ((txStatus === null || txStatus === void 0 ? void 0 : txStatus.status) === 'pending-approval')
            return 'Pending Approval';
        return 'Swap';
    }, [txStatus, errors.fromValue, loading, quoteResponseMeta]);
    return ((0, jsx_runtime_1.jsx)(JupButton_1.default, { size: "lg", className: (0, cn_1.cn)('w-full mt-4 disabled:opacity-50 !text-uiv2-text/75 !bg-primary '), onClick: onSubmit, disabled: shouldButtonDisabled, children: (0, jsx_runtime_1.jsx)("span", { children: buttonText }) }));
};
exports.SubmitButton = SubmitButton;
